import type { IPatientAddEditValidated } from '@common/validation/patient';

export enum OorZijde {
    beideOren = 'Beide oren',
    linkeroor = 'Linkeroor',
    rechteroor = 'Rechteroor',
}
export const oorZijdeOptions: OorZijde[] = [OorZijde.linkeroor, OorZijde.rechteroor, OorZijde.beideOren];

export const redenReceptData: {
    key: 'reden_recept_soloapparatuur' | 'reden_recept_wek_en_waarschuwingssysteem';
    value: string;
}[] = [
    {
        key: 'reden_recept_soloapparatuur',
        value: 'Ik adviseer soloapparatuur zodat u spraak beter kunt verstaan in situaties met meerdere mensen. Dit helpt sociaal isolement te voorkomen en verbetert uw prestaties op werk en/of school.',
    },
    {
        key: 'reden_recept_wek_en_waarschuwingssysteem',
        value: 'Reguliere oplossingen zoals een deurbelversterker of brandalarm zijn niet voldoende. Om uw veiligheid en die van uw kinderen en/of buren te waarborgen, adviseer ik een wek- en waarschuwingssysteem.',
    },
];

export enum RedenVerwijzingAudioloog {
    adviesOverigeHulpmiddelen = 'Advies overige hoorhulpmiddelen',
    anders = 'Anders',
    gesprekVanwegeTinnitus = 'Gesprek audioloog vanwege tinnitus',
    hoortoestelAdviesNaProef = 'Hoortoestel advies na proef',
    hoortoestelAdviesVoorProef = 'Hoortoestel advies voorafgaand proef',
}

export enum Slechthorendheid {
    beideOren = 'Beide oren',
    geen = 'Geen',
    linkeroor = 'Linkeroor',
    rechteroor = 'Rechteroor',
}
export const slechthorendheidOptions: Slechthorendheid[] = [
    Slechthorendheid.linkeroor,
    Slechthorendheid.rechteroor,
    Slechthorendheid.beideOren,
    Slechthorendheid.geen,
];

// TODO: CS-23832 Make this generic
export type Patient = Pick<IPatientAddEditValidated, 'emailAddress' | 'mobileNumber'>;
